import React from 'react';
import PropTypes from 'prop-types';
import styles from './regConfirmation.scss';

const ShareEventCard = (props) => {
	const { isTennis, onShowShareUrlPopup } = props;

	const sport = isTennis ? 'tennis' : 'pickleball';
	const pickleballStyling = !isTennis && styles.pickleball;

	const handleShowShareUrlPopup = () => {
		onShowShareUrlPopup();
	};

	return (
    <div className={`${styles.shareEventCard} ${pickleballStyling}`}>
        <div>
            <p className={styles.heading} data-testid="event-profile.reg-confirmation.share-event.heading">Share this event with your friends!</p>
            <p data-testid="event-profile.reg-confirmation.share-event.subtitle">The more players there are, the better the match-ups will be.</p>
        </div>
        <button
            type="button"
            onClick={handleShowShareUrlPopup}
            className={`btn btn-primary text-uppercase ${styles.shareButton}`}
            data-testid="event-profile.reg-confirmation.share-event.share-btn"
        >
            <img src={`/img/icons/${sport}_icon_with_color.svg`} alt={`${sport} icon`} />
				Share event link
        </button>
    </div>
	);
};

ShareEventCard.propTypes = {
	isTennis: PropTypes.bool.isRequired,
	onShowShareUrlPopup: PropTypes.func.isRequired,
};

export default ShareEventCard;
